<!--
 * @Description: 潜在客户新增
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-05-31 17:58:57
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <baseMessage :disabled="false" returnName="DcCosLbuPotential"  isEdit isEditPotentialOrDeal :data="data" :permissionPage="permissionBasic" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import baseMessage from '@/views/yuntuSales/customerCenter/components/baseMessage.vue'
import { useRoute } from 'vue-router'
import { potentialDetail } from '@/api/yuntuSales/customerCenter'
const route = useRoute()
const data = ref()
// 获取详情
const fetch = () => {
  if (route.query.cosId) {
    potentialDetail(route.query.cosId).then((res) => {
      data.value = res.data
    })
  }
}
onMounted(() => {
  fetch()
})
const permissionBasic = {
  save: 'lbu_potential_edit_btn'
}
</script>
<script lang="ts">
export default { name: 'DcCosLbuPotentialPerEdit' }
</script>
<style lang="scss" scoped></style>
